import Button from "atoms/buttons/button";
import { Icons } from "atoms/constants/icons";
import { ParagraphSizes } from "atoms/constants/paragraph-sizes";
import Paragraph from "atoms/typography/paragraph";
import SubscriptionTypeLabel from "molecules/subscription-type-label/subscription-type-label";
import Tooltip from "molecules/tooltips/tooltip";
import SubscriptionType from "organisms/enums/subscription-type";
import * as React from "react";
import useConfigurableAlertMessages from "utilities/hooks/use-configurable-alert-messages";

interface SubscriptionCardProps {
    billingText: string;
    buttonText: string;
    headingIcon: Icons;
    onSelect: () => void;
    price: string;
    type: SubscriptionType;
    cssClassNameModifier?: string;
    children?: React.ReactNode;
    intro?: string;
}

const SubscriptionCard: React.FunctionComponent<SubscriptionCardProps> = (
    props
) => {
    const baseClass = "c-subscription-card";
    const { subscriptionFreezeActive, alertMessageContents } =
        useConfigurableAlertMessages();

    return (
        <div
            className={`${baseClass} ${props.cssClassNameModifier ?? ""}`}
            data-test-id={props.type}>
            <div className={baseClass + "__header"}>
                <div className={baseClass + "__header__title"}>
                    <SubscriptionTypeLabel showSize={false} type={props.type} />
                </div>
            </div>
            <div className={baseClass + "__button-wrapper"}>
                <Tooltip
                    content={alertMessageContents?.tooltip}
                    disabled={!subscriptionFreezeActive}>
                    <Button
                        onClick={
                            !subscriptionFreezeActive
                                ? props.onSelect
                                : () => {}
                        }>
                        {props.buttonText}
                    </Button>
                </Tooltip>
            </div>
            {props.intro && (
                <Paragraph
                    size={ParagraphSizes.Small}
                    cssClassName={`${baseClass}__intro`}>
                    {props.intro}
                </Paragraph>
            )}
            <div className={baseClass + "__content"}>{props.children}</div>
        </div>
    );
};

export default SubscriptionCard;
